import { render } from "./CustomerNavigation.vue?vue&type=template&id=a5017936&ts=true"
import script from "./CustomerNavigation.vue?vue&type=script&lang=ts"
export * from "./CustomerNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__